import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Collapse, Radio,Checkbox,label,Input,Popover, Button ,Tooltip,TimePicker ,Modal  } from 'antd';


import attached from '../../assets/images/icon/paperclip.png';
import music from '../../assets/images/icon/music.png';
import pdf_ from '../../assets/images/icon/pdf_.png';
import image from '../../assets/images/icon/image.png';
import person from '../../assets/images/icon/person.png';
import correct from '../../assets/images/icon/correct.png';
import wrong from '../../assets/images/icon/wrong.png';
import edit from '../../assets/images/icon/edit.png';


const { Panel } = Collapse;
const { Search } = Input;
const buttonWidth = 70;

function callback(key) {
  console.log(key);
}

function onChange(time, timeString) {
  console.log(time, timeString);
}

function onChangechecked(checkedValues) {
  console.log('checked = ', checkedValues);
}

class Index extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			size: 'default',
			quant: 'default',
			like: 'default',
			comment: 'default',
			notification: 'default',
			value: '',
			
			loading: false,
			visible: false,
		}
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
	}
	
	hide = () => {
    this.setState({
      visible: false,
    });
  };
  
  handleVisibleChange = visible => {
    this.setState({ visible });
  };
	
	handleSizeChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };
  
  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.setState({ loading: false, visible: false });
    }, 3000);
  };

  handleCancel = () => {
    this.setState({ visible: false });
  };

	render()

	{
	
	const { size } = this.state;
	  const { visible, loading } = this.state;			
					
		return (
			<div>
			
			<div id="main" class="bg-off">
         <div class="row">
		 
		 	<div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
                     <div class="col s12 m6 l6 pt-10">
                        <h5 class="breadcrumbs-title"><span>Invite Staff</span></h5>
                     </div>
                     <div class="col s12 m6 l6 right-align-md pt-10">
                        <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
                           <li class="breadcrumb-item active">Invite Staff
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>
             
		 
		
      
		 	<div class="col s12 m12 ex-padd">     
            <div class="container view-Profile viewprograms">
			   <div class="col s12 m12 mb-20 card-content iq-card mh-500">
                  <section class="invoice-list-wrapper section food ">
					
					<div class="children bg-blue communication mb-20 pb-20 iq-card2 bg-color-1">
                     <Collapse defaultActivesKey={['1']} onChange={callback}>
						<Panel header="Staff"  key="1">
							<div class="children bg-blue attendance">
								
								<div class="col m12 s12 mb-10 center no-padd">
									<div class="shadow">
									<div class="col m2 s12"><img src={person} class="atd-img" /><span class="title-font">Demo Child</span> </div>
									<div class="col m8 s12">
										<div class="col m6 s12 t-left mt-10">
											<label>Name </label> : <span>Shyam Gupta</span>
										</div>
										<div class="col m6 s12 t-left mt-10">
											<label>Mobile </label> : <span>9892989298</span>
										</div>
										<div class="col m6 s12 t-left mt-10">
											<label>Email </label> : <span>shyam964@gmail.com</span>
										</div>
										<div class="col m6 s12 t-left mt-10">
											<label>Last Seen </label> : <span>05:50 PM 14 July 2020</span>
										</div>
									</div>
									<div class="col m2 s12 pt-10">
										<Button className="snd-btn"  onClick={this.showModal}>Invite</Button> 
										<Modal
										  visible={visible}
										  title="Title"
										  className="invite"
										  onOk={this.handleOk}
										  onCancel={this.handleCancel}
										  footer={[
											
										  ]}
										>
										  <p class="title">Invite Via</p>
										  <p>Whatsapp</p>
										  <p>Email</p>
										  <p>PDF</p>
										  <p>SMS</p>
										</Modal> 
										 
									</div>
									</div>
								</div>
							</div>	
							
						</Panel>
					  </Collapse>
					</div>

					<div class="children bg-blue communication mb-20 pb-20 iq-card2 bg-color-6">
                     <Collapse defaultActiveKey={['2']} onChange={callback}>
						<Panel header="Drivers"  key="2">
							<div class="children bg-blue attendance">
								 
								<p class="center"> No Drivers Found</p>  
								   
							
							</div>	
							
						</Panel>
					  </Collapse>
					</div>				
					
					
					
                  </section>
               </div>
               <div class="content-overlay"></div>
            </div>
            </div>
         </div>
      </div>
     
			</div>
		) 
	} 
}
export default Index;
